import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../hooks";

import { getVacancies } from "../../store/actions";

import Container from "../../components/Container";
import VacancyForm from "../../components/VacancyForm";
import Title from "../../components/Typography/Title";
import BackToTop from "../../components/BackToTop";
import LoaderOverlay from "../../components/LoaderOverlay";
import { Helmet } from "react-helmet";
import { RAZZLE_APP_PORTAL_LINK } from "../../constants";

import { Flex } from "../../utilities/GlobalStyle";
import OgVacancy from "../../assets/OgVacancy.png";
import * as S from "./style";

const Vacancy: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const title = id.replace(/-/g, " ");
  const { items } = useAppSelector((state) => state.vacancies);
  const position = items.find((item) => item.id === id);

  useEffect(() => {
    if (items.length === 0) {
      dispatch(getVacancies());
    }
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{`Unitiva - Careers: ${title}`}</title>
        <meta
          property="og:url"
          content={
            typeof window !== "undefined"
              ? window.location.href
              : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}`
          }
        />
        <link
          rel="canonical"
          href={
            typeof window !== "undefined"
              ? window.location.href
              : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}`
          }
        />
        <meta property="og:title" content={position && position.title} />
        <meta
          property="og:description"
          content={position && position.description}
        />
        <meta
          property="og:image"
          content={`${RAZZLE_APP_PORTAL_LINK}/theme_assets/images/OgVacancy.png`}
        />
        <meta property="og:image:type" content="image/png" />
      </Helmet>
      <LoaderOverlay isWhite={true} />
      <>
        {position && (
          <>
            <S.VacancyHeader flexDirection="column" margin={[0, 0, 16]}>
              <Container>
                <S.VacancyHeaderWrapper>
                  <Title title={position.title} />
                  <S.VacancyHeaderDetails
                    margin={[0, 64, 0, 0]}
                    alignItems="center">
                    <Flex alignItems="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28.621"
                        height="34.426"
                        viewBox="0 0 28.621 34.426">
                        <g transform="translate(1.25 1.25)">
                          <path
                            id="Path"
                            d="M29.121,14.061c0,10.158-13.061,18.865-13.061,18.865S3,24.219,3,14.061a13.061,13.061,0,0,1,26.121,0Z"
                            transform="translate(-3 -1)"
                            fill="none"
                            stroke="#4260d1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2.5"
                          />
                          <circle
                            data-name="Path"
                            cx="4.5"
                            cy="4.5"
                            r="4.5"
                            transform="translate(8.576 8.641)"
                            fill="none"
                            stroke="#4260d1"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2.5"
                          />
                        </g>
                      </svg>
                      <Title size="2.4" title={position.sede} />
                    </Flex>
                    <Flex alignItems="center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="29.5"
                        height="35.5"
                        viewBox="0 0 29.5 35.5">
                        <path
                          data-name="Tracciato 5435"
                          d="M25.56-3252.44a1.5,1.5,0,0,1-1.06.439,1.5,1.5,0,0,1-1.06-.439l-6-6a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.121,0l6,6a1.5,1.5,0,0,1,0,2.121M26-3266.912v-1.588h3.75a2.25,2.25,0,0,0,2.25-2.25,2.25,2.25,0,0,0-2.25-2.25H19.25a2.25,2.25,0,0,0-2.25,2.25,2.25,2.25,0,0,0,2.25,2.25H23v1.588A13.5,13.5,0,0,0,11-3253.5,13.5,13.5,0,0,0,24.5-3240,13.5,13.5,0,0,0,38-3253.5a13.5,13.5,0,0,0-12-13.411"
                          transform="translate(-9.75 3274.25)"
                          fill="none"
                          stroke="#4260d1"
                          strokeWidth="2.5"
                          fillRule="evenodd"
                        />
                      </svg>
                      <Title size="2.4" title={position.contratto} />
                    </Flex>
                  </S.VacancyHeaderDetails>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: position.abstract.data,
                    }}></p>
                </S.VacancyHeaderWrapper>
              </Container>
            </S.VacancyHeader>
            <Container>
              <S.VacancyDetailsWrapper>
                <S.VacancyDetails>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: position.text.data,
                    }}></div>
                </S.VacancyDetails>
                <VacancyForm title={position.title} />
              </S.VacancyDetailsWrapper>
            </Container>
            <BackToTop />
          </>
        )}
      </>
    </>
  );
};

export default Vacancy;
